import { Route } from 'vue-router';
import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { GuardClass, GuardResolveFunction } from '../models';

import { CONFIG_CONSTS } from '../store/config/config.consts';

export class LoadConfigGuard extends GuardClass {

  public static async execute(to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    if (!store.getters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.instances}`].length) {
      await store.dispatch(`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.actions.loadInstances}`);
    }
    next();
  }

}
